import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';

export default function WhatsAppButton() {
  const { language } = useLanguage();
  const phoneNumber = '32465710117';
  const message = encodeURIComponent(
    language === 'en'
      ? 'Hello, I would like to know more about your products.'
      : 'Bonjour, je souhaite en savoir plus sur vos produits.'
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  
  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring' }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      data-testid="whatsapp-button"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="font-medium hidden sm:block">WhatsApp</span>
    </motion.a>
  );
}
